import React from 'react';
import { StoreMap } from '~/features/find-store/components/StoreMap';
import { Modules, P71StoreDetailsPage as StorePage } from '~/lib/data-contract';
import { DynamicBlockList } from '~/templates/blocks';
import { usePage } from '~/templates/pages/hooks/usePage';
import styles from './P71StoreDetailsPage.module.scss';

type P71StoreDetailsPageProps = StorePage;

export const P71StoreDetailsPage = (props: P71StoreDetailsPageProps) => {
    const { data: page } = usePage();
    const { storeId } = props;
    const store = page?.storeList?.data?.find((x) => x.id == storeId);

    if (!store) {
        return null;
    }

    return (
        <>
            <div className={styles.storeDetailsContainer}>
                <div className={styles.storeDetailsContent}>
                    <StoreMap store={store} />
                </div>
            </div>

            <DynamicBlockList elements={props.bottomPageElements as Modules[]} />
        </>
    );
};
